<script>
    import { createEventDispatcher } from 'svelte'
    import validate                  from 'validate.js'
    import * as api                  from '../../shared/api.js'
    import FieldError                from '../../shared/FieldError.svelte'

    export let item
    export let profile
    export let domain

    let working = false
    let error   = false

    const dispatch = createEventDispatcher()
    
    const constraints = {
        key         : { presence: { allowEmpty: false, message: "campo obrigatório" } },
        description : { presence: { allowEmpty: false, message: "campo obrigatório" } },
    }
    
    function remove() {
        working = true
        api
            .del(`/profile/${profile.id}/constraint/${item.id}`)
            .then(res => {
                working = false
                if(res.status === 200) {
                    dispatch('remove', item)
                    error = false
                } else {
                    error = true
                }
            })
            .catch(err => {
                working = false
                error   = "Erro ao remover"
                console.log(err)
            })

    }

    function store() {
        working = true
        api
            .post(`/profile/constraint`, { domain: domain.id, profile: profile.id, ...item })
            .then(api.toJsonIf200)
            .then(json => {
                working = false
                error   = false
                dispatch('update', json)
            })
            .catch(err => {
                working = false
                error   = "Erro ao cadastrar"
                console.log(err)
            })
    }

    $: errors = validate(item, constraints, { fullMessages: false }) || {}
    $: hasErrors = Object.keys(errors).length > 0
    $: disabled = item.key === 'email'
</script>
<div class="ui segment" class:loading={working}>
    <form class="ui equal width big form">
        <div class="field"
             class:disabled
             class:error={errors.description}>
            <label>Nome</label>
            <input  bind:value={item.description}>
            <FieldError style="label" property={errors['description']}/>
        </div>
        <div class="field"
             class:disabled
             class:error={errors.key}>
            <label>Campo</label>
            <input  bind:value={item.key}>
            <FieldError style="label" property={errors['key']}/>
        </div>
        <div class="field"
             class:disabled>
            <label>Descrição</label>
            <textarea rows="3" bind:value={item.text}></textarea>
        </div>
        <div class="fields">
            <div class="field"
                 class:disabled
                 class:error={errors.htmlType}>
                <label>Tipo HTML</label>
                <input  bind:value={item.htmlType}>
                <FieldError style="label" property={errors['htmlType']}/>
            </div>
            <div class="field"
                 class:disabled
                 class:error={errors.pattern}>
                <label>Regex</label>
                <input  bind:value={item.pattern}>
                <FieldError style="label" property={errors['pattern']}/>
            </div>
        </div>
        <div class="fields">
            <div class="field"
                 class:disabled
                 class:error={errors.minLen}>
                <label>Tamanho Mínimo</label>
                <input  bind:value={item.minLen} maxlength="3">
                <FieldError style="label" property={errors['minLen']}/>
            </div>
            <div class="field"
                 class:disabled
                class:error={errors.maxLen}>
                <label>Tamanho Máximo</label>
                <input  bind:value={item.maxLen} maxlength="3">
                <FieldError style="label" property={errors['maxen']}/>
            </div>
        </div>
        <div class="field" class:disabled>
            <div class="ui toggle checkbox">
                <input type="checkbox" bind:checked={item.required}>
                <label>Obrigatório</label>
            </div>
        </div>
        <div class="ui right aligned basic segment">
            {#if item.id === 0}
                <button class="ui button" 
                        class:disabled
                        on:click={() => dispatch('cancel', item) }>
                    Cancelar
                </button>
                <button class="ui blue button" 
                        on:click|preventDefault={store} 
                        class:disabled={hasErrors || disabled}>
                    Adicionar
                </button>
            {:else}
                <button class="ui button" 
                        class:disabled
                        on:click|preventDefault={remove}>
                    Remover
                </button>
                <button class="ui blue button" 
                        on:click|preventDefault={store} 
                        class:disabled={hasErrors || disabled}>
                    Atualizar
                </button>
            {/if}
        </div>

    </form>
</div>

<style>
    .segment, .form {
        background-color: #f8f8f8;
    }
</style>
